import React, { useState, useEffect } from 'react';
import { IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const MAX_FILE_SIZE_MB = 0.5;

const ImageUploadField = ({
    imageFile,
    onChange,
    onRemove,
    size = 100,
}) => {
    const [error, setError] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);

    // プレビューURL管理（メモリリーク防止）
    useEffect(() => {
        if (imageFile?.file && !imageFile.willDelete) {
            const url = URL.createObjectURL(imageFile.file);
            setPreviewUrl(url);

            return () => {
                URL.revokeObjectURL(url);
            };
        }

        setPreviewUrl(null);
    }, [imageFile]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // MIMEタイプチェック（画像のみ）
        if (!file.type.startsWith('image/')) {
            setError('画像ファイルではありません');
            e.target.value = '';
            return;
        }

        // ファイルサイズチェック
        if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
            setError(`画像は${MAX_FILE_SIZE_MB}MB以下にしてください`);
            e.target.value = '';
            return;
        }

        setError('');
        onChange(e);
    };

    const backgroundImage =
        imageFile && !imageFile.willDelete
            ? previewUrl
                ? previewUrl
                : `${process.env.REACT_APP_IMAGE_BASE_URL}${imageFile.image_url}`
            : `${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_NOIMAGE}`;

    return (
        <div style={{ position: 'relative', width: size, height: size }}>
            {imageFile && !imageFile.willDelete && (
                <IconButton
                    onClick={onRemove}
                    size="small"
                    sx={{
                        position: 'absolute',
                        top: 2,
                        right: 2,
                        backgroundColor: 'rgba(255,255,255,0.8)',
                        '&:hover': {
                            backgroundColor: 'rgba(255,255,255,1)',
                        },
                    }}
                >
                    <Close sx={{ fontSize: 14 }} />
                </IconButton>
            )}

            <label
                style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    borderRadius: 4,
                    cursor: 'pointer',
                }}
            >
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />
            </label>

            {error && (
                <Typography
                    variant="caption"
                    color="error"
                    sx={{ display: 'block', mt: 0.5 }}
                >
                    {error}
                </Typography>
            )}
        </div>
    );
};

export default ImageUploadField;
